import { Validator } from '@vista-digital/validator';
import { structuredDataConfigValidator } from '../../../types/structured-data-config';
/**
 * Default configuration options for the Film Context component.
 */
export const defaultFilmContextConfig = {
    structuredData: {
        enable: false
    }
};
export const filmContextConfigValidatorSchema = {
    structuredData: structuredDataConfigValidator
};
export const filmContextConfigValidator = Validator.object(filmContextConfigValidatorSchema);
